import { Card, CardContent } from '@/components/ui/card'
import { CountryRate } from '@/types/pricing'
import { useCurrency } from '@/hooks/useCurrency'
import { useTranslation } from 'react-i18next'
import { Link } from '@tanstack/react-router'
import { countryToSlug } from '@/lib/countries'
import { useLang } from '@/hooks/useLang'
import { Flag } from '@/components/Flag'

interface PricingCountryCardProps {
  country: CountryRate
  className?: string
}

export function PricingCountryCard({ country, className }: PricingCountryCardProps) {
  const { formatCurrency } = useCurrency()
  const { t } = useTranslation('marketing')
  const lang = useLang()

  return (
    <Link
      to="/$lang/rates/$country"
      params={{ lang, country: countryToSlug(country.countryCode) }}
    >
      <Card className={`hover:shadow-lg transition-shadow duration-200 aspect-[4/3] ${className ?? ''}`}>
        <CardContent className="p-3 h-full flex flex-col justify-between">
          <div className="flex items-center gap-2 mb-2">
            <Flag countryCode={country.countryCode} size="xl" />
            <div className="font-semibold text-base text-foreground leading-tight">{t(`countries.${country.countryCode}`)}</div>
          </div>
          <div className="grid grid-cols-2 gap-2 text-xs">
            <div>
              <div className="text-2xs text-muted-foreground mb-0.5">{t('pricing.landlineRate')}</div>
              <div className="text-primary font-semibold">
                {t('pricing.rateWithUnit', { rate: formatCurrency(country.landlineRate) })}
              </div>
            </div>
            <div>
              <div className="text-2xs text-muted-foreground mb-0.5">{t('pricing.mobileRate')}</div>
              <div className="text-primary font-semibold">
                {t('pricing.rateWithUnit', { rate: formatCurrency(country.mobileRate) })}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  )
}
